
    import '/opt/buildhome/repo/packages/x/docs/x-markdown/plugin-latex.en-US.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-x-markdown-plugin-latex-demo-basic","docs-x-markdown-plugin-latex-demo-streaming"],
  getter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/packages/x/docs/x-markdown/plugin-latex.en-US.md?type=demo')
};